import getEnvironmentName from './getEnvironmentName';

const isRunningOnProd = getEnvironmentName() === 'prod';

const isProd = () => isRunningOnProd;

export default isProd;
